import { useMediaQuery } from '@vueuse/core'
/*
screens: {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
},
*/

export const screenIsSm = useMediaQuery('(max-width: 640px)')
